import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import PurchaseProductComponent from '../components/PurchaseProductComponent';
import PurchaseShippingComponent from '../components/PurchaseShippingComponent';
import PurchasePaymentComponent from '../components/PurchasePaymentComponent';
import ChangePurchaseComponent from '../components/ChangePurchaseComponent';
import GiftCardSaleComponent from '../components/GiftCardSaleComponent';
import GiftCardCodesModal from '../components/GiftCardCodesModal';

import { convertToMoney } from '../utils/formats';
import { validateSession } from  '../utils/functions';
import { isAcceptableEmail, EMAIL_INVALIDO_MSG } from '../utils/email';
import { navigateTo } from '../utils/navigation';
import { totalACobrar, totalDeLaVenta, topeDelSaldo, baseDelSaldo, mensajeDeError } from '../utils/giftCards';

var config = process.env;

class AddPurchasePage extends Component {

    constructor() {
        super();
        this.state = {
            msgError: "",
            showError: false,
            enabled: true,
            products: {},
            changedProducts: {},
            payment: {
                method: 5,
                promo_code: "",
                gift_card_code: ""
            },
            shippingMethod: 2,
            total_price: 0,
            change: 0,
            inFavour: 0,
            finalPrice: 0,
            creditBalance: null,
            creditApplied: '',
            discountNotice: '',
            // Gift card a VENDER (FR-001): { amount, quantity } o null. No pasa por
            // calculatePrice: se suma aparte al total a cobrar (ver totalACobrar).
            giftCardSale: null,
            // Gift card a USAR, según la calculó el backend (FR-032):
            // { amount, applied, leftover, difference, total, display } o null.
            giftCardUse: null,
            giftCardNotice: '',
            // Gift cards creadas por la venta recién confirmada: abre el modal de códigos (FR-005).
            soldGiftCards: null
        }
    }

    // ENI-205: tope del crédito aplicable = lo que el cliente debería pagar en efectivo
    // (precio final - dinero a favor por canje) y, si ya se consultó, su saldo. Clampea en
    // el onChange (el atributo max no impide tipear de más en un input number) para que nunca
    // se pueda aplicar más crédito que el total — el backend igual reclampa (ENI-205).
    // Gift cards: el tope sale de los productos, nunca de las gift cards que se venden (FR-007).
    creditCap = () => {
        return topeDelSaldo({
            finalPrice: this.state.finalPrice,
            // Con una gift card aplicada el saldo cubre como máximo la diferencia (FR-040).
            giftCardUse: this.state.giftCardUse,
            inFavour: this.state.inFavour,
            balance: this.state.creditBalance,
        });
    }

    onChangeCredit = (raw) => {
        if (raw === '') {
            this.setState({ creditApplied: '' });
            return;
        }
        const n = Number(raw);
        if (Number.isNaN(n)) {
            return;
        }
        const clamped = Math.max(0, Math.min(n, this.creditCap()));
        this.setState({ creditApplied: String(clamped) });
    }

    // ENI-205: re-clampa el crédito YA tipeado cuando cambia el tope (baja el total al quitar
    // productos/aplicar cupón, sube el dinero a favor de un canje, o se consulta el saldo
    // después). El clamp del onChange solo actúa al tipear; sin esto quedaría un crédito por
    // encima del tope y el "Precio final" se iría a negativo.
    reconcileCredit = () => {
        const current = Number(this.state.creditApplied);
        if (!(current > 0)) return;
        const cap = this.creditCap();
        if (current > cap) {
            this.setState({ creditApplied: cap > 0 ? String(cap) : '' });
        }
    }

    fetchCustomerCredit = () => {
        const cedulaEl = document.getElementById("cedula");
        const cedula = cedulaEl ? cedulaEl.value : "";
        if (!cedula) {
            alert("Ingresá la cédula del cliente primero.");
            return;
        }
        const request = {
            method: 'GET',
            headers: { 'access-token': localStorage.getItem('token'), 'Content-Type': 'application/json' },
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + `store-credit/${cedula}`, request)
            .then((r) => r.json())
            .then((data) => {
                if (data.error > 0) {
                    alert(data.message);
                } else {
                    this.setState({ creditBalance: data.data.balance }, this.reconcileCredit);
                }
            });
    }

    async componentDidMount() {
        let role = await validateSession()

        const searchParams = new URLSearchParams(this.props.location.search);
        const changeParam = searchParams.get('change');

        this.setState({ 
            checked: true, 
            role:  role,
            change: changeParam ? parseInt(changeParam) : 0});
    }

    // Lo que queda por pagar de los productos: la diferencia si hay una gift card aplicada.
    productsToPay = () => {
        return this.state.giftCardUse ? baseDelSaldo(this.state.finalPrice, this.state.giftCardUse) : this.state.finalPrice;
    }

    updatePrice = (products, payment, options = {}) => {
        var code = payment.promo_code;
        // Gift card a usar (FR-030). En un cambio no se ofrece, igual que el cupón.
        var giftCardCode = this.state.change === 0 ? String(payment.gift_card_code || '').trim() : '';
        var productsList = [];
        for (const [key, value] of Object.entries(products)) {
            productsList.push({
                quantity: value.quantity,
                price: value.price,
                discount: value.discount,
                code: value.code
            });
        }
        var request = {
            method: 'POST',
            headers: { 
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                code: code,
                products: productsList,
                // El backend aplica solo el descuento por medio de pago (efectivo /
                // transferencia). Sin esto el preview mostraría un total y la venta se
                // registraría con otro. En un cambio no se manda, porque ahí la venta
                // tampoco lo aplica (ver isPurchaseChange en el submit).
                paymentType: this.state.change === 0 ? payment.method : undefined,
                // Con gift card el backend aplica el 3x2 antes que el 5%, y el 5% sólo sobre
                // la diferencia (FR-033); devuelve además aplicado / sobrante / diferencia.
                giftCardCode: giftCardCode !== '' ? giftCardCode : undefined,
                // El envío gratis desde $3000 participa de la elección del descuento: sin
                // esto el preview podía elegir un escenario distinto del que cobra la venta.
                shippingType: this.state.shippingMethod
            })
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'purchase/calculatePrice', request)
        .then(results => { return results.json(); })
        .then(data => {
            if (data.error > 0 && giftCardCode !== '' && Number(data.error) !== 1002) {
                // El código no sirve (mal escrito, usado, vencido, con cupón…): se avisa al
                // lado del total y el precio se recalcula sin la tarjeta, para que no quede
                // en pantalla el descuento de una tarjeta anterior. Si se confirma igual, el
                // backend la rechaza con el mismo motivo.
                this.setState({ giftCardUse: null, giftCardNotice: mensajeDeError(data) });
                this.updatePrice(products, { ...payment, gift_card_code: '' }, { keepGiftCardNotice: true });
            } else if (data.error > 0) {
                alert(data.message);
                if (data.error == 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
            } else {
                var finalPrice = convertToMoney(data.data.price.final_price);
                var originalPrice = convertToMoney(data.data.price.original_price);
                if (finalPrice != originalPrice) {
                    document.getElementById("total_price").innerHTML = originalPrice;
                } else {
                    document.getElementById("total_price").innerHTML = ""   
                }
                document.getElementById("total_price_discount").innerHTML = finalPrice;
                // Si el cajero tipeó un código y NO fue el que ganó, hay que decírselo:
                // si no, le avisa al cliente que se lo aplicó y el cupón sigue sin usarse.
                var codeStatus = data.data.price.codeStatus;
                var source = data.data.price.source;
                var discountNotice = "";
                if (codeStatus === "invalid") {
                    discountNotice = "El código no existe, está vencido o ya se usó.";
                } else if (codeStatus === "not_applicable") {
                    discountNotice = "El código es válido pero no corresponde a estos productos.";
                } else if (codeStatus === "applicable" && source !== "code") {
                    discountNotice = "El código no se aplicó porque el otro descuento es mayor. El cupón queda sin usar.";
                }
                this.setState({
                    finalPrice: data.data.price.final_price,
                    discountNotice: discountNotice,
                    giftCardUse: giftCardCode !== '' && data.data.giftCard ? data.data.giftCard : null,
                    giftCardNotice: options.keepGiftCardNotice ? this.state.giftCardNotice : ''
                }, this.reconcileCredit)
            }
        });
    }

    handlerSelectProduct = (value) => {
        this.setState({products: value});
        this.updatePrice(value, this.state.payment)
    }
    
    handlerSelectChangedProduct = (value, inFavour) => {
        this.setState({changedProducts: value, inFavour: inFavour});
        this.updatePrice(this.state.products, this.state.payment)
    }

    handlerSelectPayment = (value) => {
        this.setState({payment: value});
        this.updatePrice(this.state.products, value)
    }

    // La gift card a vender no cambia el precio de los productos: no se recalcula nada.
    handlerGiftCardSale = (sale) => {
        this.setState({ giftCardSale: sale });
    }

    handlerSelectShipping = (value) => {
        // El envío participa del precio (es gratis desde $3000, y ese umbral decide si
        // conviene aplicar el descuento), así que hay que recalcular igual que al cambiar
        // el medio de pago.
        this.setState({
            shippingMethod: value
        }, () => this.updatePrice(this.state.products, this.state.payment));
    }

    validateData = () => {
        if (!this.state.enabled) {
            console.log("not enabled")
            return;
        }

        if( this.state.change !== 0)
        {
            if (this.state.inFavour == 0)
            {
                this.setState({
                    msgError: "Agrega al menos un producto a cambiar",
                    showError: true
                });
                window.scrollTo({ top: 0, behavior: 'smooth' });
                return;
            }
        }
        
        var size = Object.getOwnPropertyNames(this.state.products).length;
        // Una venta que es sólo gift cards no lleva productos de catálogo.
        if (size == 0 && !this.state.giftCardSale) {
            this.setState({
                msgError: "Agrega al menos un producto o una gift card",
                showError: true
            });
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return;
        } else {
            this.setState({ showError: false });
        }
        
        var hasError = false;
        var firstname = document.getElementById("firstname");
        var lastname = document.getElementById("lastname");
        var address = document.getElementById("address");
        var cedula = document.getElementById("cedula");
        var isCompany = document.getElementById("isCompany");
        var rut = document.getElementById("rut");
        var razonSocial = document.getElementById("razonSocial");
        var direccionFiscal = document.getElementById("direccionFiscal");

        if (cedula.value == undefined || cedula.value == "") {
            cedula.classList.add("is-invalid");
            hasError = true;
        } else {
            cedula.classList.remove("is-invalid");
        }
        if (firstname.value == undefined || firstname.value == "") {
            firstname.classList.add("is-invalid");
            hasError = true;
        } else {
            firstname.classList.remove("is-invalid");
        }
        if (lastname.value == undefined || lastname.value == "") {
            lastname.classList.add("is-invalid");
            hasError = true;
        } else {
            lastname.classList.remove("is-invalid");
        }
        if (address.value == undefined || address.value == "") {
            address.classList.add("is-invalid");
            if (this.state.shippingMethod == 1) {
                hasError = true;
            }
        } else {
            address.classList.remove("is-invalid");
        }

        if (isCompany.checked) {
            if (rut.value == undefined || rut.value == "") {
                rut.classList.add("is-invalid");
                hasError = true;
            } else {
                rut.classList.remove("is-invalid");
            }
            if (razonSocial.value == undefined || razonSocial.value == "") {
                razonSocial.classList.add("is-invalid");
                hasError = true;
            } else {
                razonSocial.classList.remove("is-invalid");
            }
            if (direccionFiscal.value == undefined || direccionFiscal.value == "") {
                direccionFiscal.classList.add("is-invalid");
                hasError = true;
            } else {
                direccionFiscal.classList.remove("is-invalid");
            }
        }

        if (hasError) {
            console.log("hasError")
            return;
        }

        this.insertUser()
    }

    insertUser = () => {
        this.setState({enabled: false, msgError: "", showError: false});
        
        var department = document.getElementById("department").value;
        var city = document.getElementById("city").value;
        var address = document.getElementById("address").value;
        var email = document.getElementById("email").value;
        var phone = document.getElementById("phone").value;

        var isCompany = document.getElementById("isCompany");
        
        var rut = "";
        var razonSocial = "";
        var direccionFiscal = "";

        if (this.state.shippingMethod == 2) {
            city = "";
            department = "";
            address = "";
        }

        if (isCompany.checked) {
            rut = document.getElementById("rut").value;
            razonSocial = document.getElementById("razonSocial").value;
            direccionFiscal = document.getElementById("direccionFiscal").value;
        }

        if (email == undefined) {
            email = "";
        }
        if (phone == undefined) {
            phone = "";
        }

        // El email queda OPCIONAL, pero si viene cargado tiene que tener forma
        // de dirección. Acá es donde entraba el `-` que se tipeaba para pasar el
        // campo: al facturar esa ficha, la eFactura sale hacia SES, que rechaza
        // la llamada y deja el envío marcado como fallado. Se corta antes de
        // guardar, que es el único momento en que hay alguien para corregirlo.
        if (!isAcceptableEmail(email)) {
            this.setState({ enabled: true, msgError: EMAIL_INVALIDO_MSG, showError: true });
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return;
        }
        email = email.trim();

        var request = {
            method: 'POST',
            headers: { 
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                firstName: document.getElementById("firstname").value,
                lastName: document.getElementById("lastname").value,
                phone: phone,
                email: email,
                cedula: document.getElementById("cedula").value,
                password: "",
                address: address,
                city: city,
                department: department,
                rut: rut,
                razonSocial: razonSocial,
                direccionFiscal: direccionFiscal
            })
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'user/insertOrUpdate', request)
        .then(results => { return results.json(); })
        .then(data => {
            if (data.error != 0) {
                this.setState({enabled: true, msgError: data.message, showError: true});
                window.scrollTo({ top: 0, behavior: 'smooth' });
            } else {
                // Insert purchase
                this.insertPurchase()
            }
        });
    }

    insertPurchase = () => {
        var products = [];
        for (const [key, value] of Object.entries(this.state.products)) {
            products.push({
                prefix: value.prefix,
                code: value.code,
                quantity: value.quantity,
                productType: value.productType
            });
        }
        var providerId = -1;
        if (document.getElementById("provider").value != undefined && document.getElementById("provider").value != '') {
            providerId = parseInt(document.getElementById("provider").value);
        }

        var isCompany = document.getElementById("isCompany");
        var rut = "";
        if (isCompany.checked) {
            rut = document.getElementById("rut").value;
        }
        
        var request = {
            method: 'POST',
            headers: { 
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                cedula: document.getElementById("cedula").value,
                paymentType: this.state.payment.method,
                // F1 del arqueo: sólo tiene sentido con tarjeta; el backend igual lo descarta
                // si el medio es otro.
                posDeviceId: this.state.payment.method === 5 && this.state.payment.posDeviceId
                    ? Number(this.state.payment.posDeviceId)
                    : undefined,
                discountCode: this.state.change === 0 ? document.getElementById("promo_code").value: "",
                // Gift card a usar (FR-030); excluyente con el cupón (el backend responde 3306).
                giftCardCode: this.state.change === 0 && document.getElementById("gift_card_code") && document.getElementById("gift_card_code").value.trim() !== ""
                    ? document.getElementById("gift_card_code").value.trim()
                    : undefined,
                products: products,
                shippingType: this.state.shippingMethod,
                shippingPrice: 0,
                shippingHourPreference: document.getElementById("hour_preference").value,
                shippingAddress: document.getElementById("address").value,
                shippingCity: document.getElementById("city").value,
                shippingDepartment: document.getElementById("department").value,
                paymentData: "",
                provider: providerId,
                rut: rut,
                creditApplied: Number(this.state.creditApplied || 0),
                // Gift cards a vender: una sola entrada { amount, quantity } (FR-001). En un
                // cambio no se ofrecen (el backend las rechaza).
                giftCards: this.state.change === 0 && this.state.giftCardSale ? [this.state.giftCardSale] : undefined,
                // En un cambio se anula el descuento por medio de pago, igual que el cupón
                // de acá arriba: lo devuelto se valúa a los precios a los que se vendió.
                isPurchaseChange: this.state.change !== 0
            })
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'purchase', request)
        .then(results => { return results.json(); })
        .then(data => {
            if (data.error != 0) {
                console.log(data);
                this.setState({enabled: true, msgError: data.message, showError: true});
                window.scrollTo({ top: 0, behavior: 'smooth' });
            } else {
                if(this.state.change)
                {
                    this.insertChange(data.data.external_reference)
                }
                else if (data.data && Array.isArray(data.data.giftCards) && data.data.giftCards.length > 0)
                    // FR-005: antes de irse, los códigos para copiar en las tarjetas.
                    this.setState({ soldGiftCards: data.data.giftCards });
                else
                    navigateTo('/purchase');
            }
        });
    }

    insertChange = (newPurchaseId) => {
        let changedProductsArray = []
        for(let key in this.state.changedProducts)
        {
            changedProductsArray.push(this.state.changedProducts[key])
        }
        var request = {
            method: 'POST',
            headers: { 
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                newPurchaseId: newPurchaseId.toString(),
                changedPurchaseId: this.state.change.toString(),
                changedPurchaseItems: changedProductsArray
            })
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'purchase/change', request)
        .then(results => { return results.json(); })
        .then(data => {
            if (data.error != 0) {
                console.log(data);
                this.setState({enabled: true, msgError: data.message, showError: true});
                window.scrollTo({ top: 0, behavior: 'smooth' });
            } else {
                navigateTo('/purchase');
            }
        });
    }

    render() {
        if (!this.state.checked) {
            return (<div></div>);
        } else {
            let subtitle = "Nueva venta"
            if(this.state.change > 0)
                subtitle = "Nuevo Cambio"
            return (  
                <div className="container-fluid">
                    <div className="row">
                        <SidebarComponent itemSelected={8} role={this.state.role}/>
                        <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                            <NavbarComponent role={this.state.role} />
                            <div className="alert alert-danger alert-dismissible fade show mb-0" style={{display: this.state.showError?"block":"none"}}>{ this.state.msgError }</div>
                            <div className="main-content-container container-fluid px-4 mb-4" style={{paddingBottom: '40px'}}>
                                <HeaderComponent title="Venta" subtitle={subtitle}/>
                                <div className="row">
                                    {this.state.change != 0 ? 
                                    <ChangePurchaseComponent onChangeData={ this.handlerSelectChangedProduct } originalPurchase={this.state.change} /> : ""
                                    }
                                    <PurchaseProductComponent onChangeData={ this.handlerSelectProduct } isPurchaseChange={this.state.change !== 0}/>
                                    {this.state.change === 0 ? (
                                        <GiftCardSaleComponent onChangeData={ this.handlerGiftCardSale } />
                                    ) : ""}
                                    <PurchaseShippingComponent onChangeData={ this.handlerSelectShipping }/>
                                    <PurchasePaymentComponent onChangeData={ this.handlerSelectPayment } isPurchaseChange={this.state.change !== 0}/>
                                    <div className="col-lg-12">
                                        <div className="card card-small mb-4">
                                            <div className="card-body p-3">
                                                <h6 className="text-uppercase text-muted">Crédito en tienda</h6>
                                                <div className="row align-items-end">
                                                    <div className="col-md-5">
                                                        <button type="button" className="btn btn-white" onClick={this.fetchCustomerCredit}>Ver saldo del cliente</button>
                                                        {this.state.creditBalance != null && (
                                                            <span style={{marginLeft: '12px'}}>Saldo: <strong>$ {convertToMoney(this.state.creditBalance)}</strong></span>
                                                        )}
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label>Aplicar crédito</label>
                                                        <input type="number" min="0" max={this.creditCap()} step="1" className="form-control" value={this.state.creditApplied} onChange={(e) => this.onChangeCredit(e.target.value)} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="card card-small mb-4">
                                            <div style={{fontSize: '24px', textAlign: 'center'}}>
                                                {totalDeLaVenta(this.state.giftCardSale) > 0 && (
                                                    <div id="gift_card_sale_total" style={{fontSize: '15px', color: '#5a6169'}}>Gift cards ({this.state.giftCardSale.quantity} × $ {convertToMoney(this.state.giftCardSale.amount)}): <strong>+ $ {convertToMoney(totalDeLaVenta(this.state.giftCardSale))}</strong></div>
                                                )}
                                                {this.state.giftCardUse && (
                                                    <div id="gift_card_use" style={{fontSize: '15px', color: '#5a6169'}}>
                                                        Gift card {this.state.giftCardUse.display}: <strong>- $ {convertToMoney(Number(this.state.giftCardUse.applied) || 0)}</strong>
                                                        {Number(this.state.giftCardUse.leftover) > 0 && (
                                                            <div style={{fontSize: '14px', color: '#17c671'}}>
                                                                Sobran $ {convertToMoney(Number(this.state.giftCardUse.leftover))}: quedan como saldo a favor de la cédula de esta venta (no puede ser consumidor final).
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                                {Number(this.state.creditApplied) > 0 && (
                                                    <div style={{fontSize: '15px', color: '#5a6169'}}>Crédito en tienda: <strong>- $ {convertToMoney(Number(this.state.creditApplied))}</strong></div>
                                                )}
                                                <label>Precio final: </label>
                                                <strong style={this.state.finalPrice - this.state.inFavour < 0 ? {marginLeft: '13px', color:"red"} : {marginLeft: '13px'}}>$ <span  id="final_price">{convertToMoney(totalACobrar(this.productsToPay(), this.state.giftCardSale) - this.state.inFavour - (Number(this.state.creditApplied) || 0))}</span></strong>
                                                {this.state.finalPrice - this.state.inFavour < 0 ? (<div style={{marginLeft: '13px', color:"red"}}> <span id="warning">AUN HAY DINERO A FAVOR DEL CLIENTE, COMPROBAR NO QUIERE NADA MAS</span></div>) : ""}
                                                {this.state.giftCardNotice ? (<div style={{fontSize: '14px', color: '#c4183c', marginTop: '6px'}}><span id="gift_card_notice">{this.state.giftCardNotice}</span></div>) : ""}
                                                {this.state.discountNotice ? (<div style={{fontSize: '14px', color: '#c69500', marginTop: '6px'}}><span id="discount_notice">{this.state.discountNotice}</span></div>) : ""}
                                            </div>
                                        </div>
                                        </div>
                                </div>
                                
                                {this.state.soldGiftCards ? (
                                    <GiftCardCodesModal cards={this.state.soldGiftCards} onClose={() => navigateTo('/purchase')} />
                                ) : ""}
                                <button 
                                    disabled={!this.state.enabled}
                                    type="button" 
                                    class="mb-2 btn btn-primary" 
                                    style={{float: 'right', width: '200px', marginBottom: '25px !important'}} 
                                    onClick={() => this.validateData() }>
                                        {this.state.enabled?'Confirmar':<div className="min-loader"></div>}
                                </button>
                            </div>
                        </main>
                    </div>
                </div>
            );
        }
    }
}

export default AddPurchasePage;
